import AccountContext from "configurator-studio-arkitekter-components/dist/common/components/Account/context";

export default AccountContext;
